import {
  filter, find, get, isEmpty, isNull, map, pickBy,
} from 'lodash';
import React, { useContext, useMemo } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import menuContext from '../contexts/menu';
import MenuAdCmp from '../components/MenuAd';

export default function MenuAd() {
  const { id } = useParams();
  const { menuCache } = useContext(menuContext);
  const { menuAdvertisementsDict, productProviderInfo, products } = menuCache || {};

  const data = useMemo(() => {
    if (isEmpty(menuAdvertisementsDict)) return {};

    const ad = get(menuAdvertisementsDict, [id], null);

    if (isNull(ad)) return null;

    const { providers } = ad;

    ad.providers = filter(map(providers, (item) => {
      const { name, description } = item;
      const provider = find(productProviderInfo, ['provider', name]);

      if (isEmpty(provider)) return null;

      const { coverImage, introduction } = provider || {};

      return {
        ...item,
        coverImage,
        description: description || introduction,
        productDict: pickBy(products, ['provider', name]),
      };
    }), (provider) => {
      const { productDict } = provider || {};

      if (isEmpty(provider)) return false;
      if (isEmpty(productDict)) return false;

      return true;
    });

    return ad;
  }, [menuAdvertisementsDict, productProviderInfo, id, products]);

  return isNull(data)
    ? <Redirect to="/menu" replace />
    : (
      <MenuAdCmp
        data={data}
      />
    );
}
